import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { UnboxingPage } from './pages/UnboxingPage';
import { TwoBricksPage } from './pages/TwoBricksPage';
import { GTMProvider } from './components/GTMProvider';
export function App() {
  useEffect(() => {
    document.title = 'Blue Brick Unboxing';
  }, []);
  return <GTMProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Navigate to="/products/brick/unboxing" replace data-id="element-4" />} data-id="element-3" />
          <Route path="/products/brick/unboxing" element={<UnboxingPage data-id="element-6" />} data-id="element-5" />
          <Route path="/products/brick/two-bricks" element={<TwoBricksPage data-id="element-8" />} data-id="element-7" />
        </Routes>
      </BrowserRouter>
    </GTMProvider>;
}